import React from 'react';

const LowResolutionPreviewTag: React.FC<{ isVisible: boolean }> = ({ isVisible }) => {
  if (!isVisible) {
    return <></>;
  }
  return (
    <div
      data-skip-in-thumbnail-generation
      className="absolute right-[6px] top-[6px] rounded-md bg-black px-1.5 py-1 text-2xs text-white opacity-60"
    >
      Low-res preview
    </div>
  );
};

export default LowResolutionPreviewTag;
